import Vue from 'vue'
import Vuex from 'vuex'
import layout from './modules/layout'
import user from './modules/user'
import folders from './modules/folders'
import serviceTypes from './modules/serviceTypes'
import recommendations from './modules/recommendations'
import providers from './modules/providers'
import heatmap from './modules/heatmap'
import geo from './modules/geo'
import geoBrowser from './modules/geoBrowser'
import providerStats from './modules/providerStats'
import search from './modules/search'
import providerInfo from './modules/providerInfo'
import pages from './modules/pages'
import serviceTypePage from './modules/serviceTypePage'
import flashMessages from './modules/flashMessages'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    layout,
    user,
    folders,
    serviceTypes,
    recommendations,
    providers,
    providerStats,
    heatmap,
    geo,
    geoBrowser,
    search,
    providerInfo,
    pages,
    serviceTypePage,
    flashMessages
  }
})

export default store



// WEBPACK FOOTER //
// ./frontend/src/store/index.js